var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRetrievePlayerByUserId, useRetrieveTeam, useRetrieveUserTeamPermissions, useUpdateTeam, } from "../ApiProvider";
import { UserContext } from "../auth/UserProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { TeamForm } from "./TeamForm";
export var UpdateTeam = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveUserTeamPermissions({ teamId: id }), userTeamPermissions = _a.data, userTeamPermissionsIsLoading = _a.isLoading, userTeamPermissionsError = _a.error;
    var _b = (userTeamPermissions || {}).canModify, canModify = _b === void 0 ? false : _b;
    var _c = useRetrieveTeam({ id: id, enabled: canModify }), isLoading = _c.isLoading, teamError = _c.error, team = _c.data;
    var _d = useContext(UserContext), contextUser = _d.user, isContextUserLoading = _d.loading;
    var _e = useRetrievePlayerByUserId({
        userId: contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk,
        enabled: canModify,
    }), player = _e.data, isPlayerLoading = _e.isLoading, playerError = _e.error;
    var _f = __read(useState(false), 2), loading = _f[0], setLoading = _f[1];
    var navigate = useNavigate();
    var isPlayerInTeam = team && player
        ? (team.players || []).some(function (playerId) { return playerId === player.id; })
        : false;
    var isManagerOfTeam = team && contextUser ? team.manager === contextUser.pk : false;
    var mutation = useUpdateTeam({
        id: id,
        onMutate: function () {
            setLoading(true);
        },
        onSuccess: function (data) {
            var team = data.data;
            navigate("/teams/".concat(team.id, "/"));
        },
        onError: function () { },
    });
    var onSubmit = function (data) {
        mutation.mutate(data);
    };
    if (userTeamPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userTeamPermissionsError) {
        return _jsx(ErrorView, { error: userTeamPermissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (isLoading || loading || isContextUserLoading || isPlayerLoading) {
        return _jsx(Loading, {});
    }
    if (teamError || !team || playerError) {
        return _jsx(ErrorView, { error: teamError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update team. Please try again.", onClose: function () { } }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Update ", team.name] }) }), _jsx(TeamForm, { team: team, onSubmit: onSubmit, defaultAddAsPlayer: isPlayerInTeam, defaultAddAsManager: isManagerOfTeam })] }));
};
